import { createSlice } from "@reduxjs/toolkit";

const orderSlice = createSlice({
    name: "order",
    initialState: {
        orders: [],
        page: 1,
        pages: 1,
        count: 1,
        total: 0,
        shipping: 0,
        // The billable slice of the same filters — the rows a vendor statement
        // would actually charge for. Rendered beside the totals above so the
        // orders page can show "how many orders" and "how many of them are
        // billable" side by side instead of one number standing for both.
        // Defaulted to 0, and coerced below, because an older API build (or a
        // cached response) simply omits them.
        billedCount: 0,
        billedTotal: 0,
    },
    reducers: {
        setOrders(state, action) {
            const data = action.payload;
            state.orders = data.results;
            state.pages = data.pages;
        },
        setOrderStats(state, action) {
            const data = action.payload;
            state.count = data.count;
            state.shipping = data.totalShipping;
            state.total = data.total;
            state.billedCount = data.billedCount ?? 0;
            state.billedTotal = data.billedTotal ?? 0;
        },
        updateOrderInList(state, action) {
            const { id, data } = action.payload;
            const idx = state.orders.findIndex((o) => o.id === id);
            if (idx !== -1) {
                state.orders[idx] = { ...state.orders[idx], ...data };
            }
        },
        setPage(state, action) {
            const page = action.payload;
            state.page = page;
        },
    },
});

export const { setOrders, setOrderStats, setPage, updateOrderInList } = orderSlice.actions;

export default orderSlice;
